import { render, staticRenderFns } from "./CustomersPerSeller.vue?vue&type=template&id=a3de5e66&"
import script from "./CustomersPerSeller.vue?vue&type=script&lang=js&"
export * from "./CustomersPerSeller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports